import React, {useEffect, useState} from "react";
import {IconButton, Popover} from "@material-ui/core";
import MaterialUISelect from "../../../common/selects/MaterialUISelect";
import TextField from "@material-ui/core/TextField/TextField";
import Done from "@material-ui/icons/DoneOutlined";
import Cancel from '@material-ui/icons/ClearOutlined';
import {TB_STATUS_ACTIVE} from "../../../../utils/constants";

export default function TbInfoEditPopover({button, tbInfo,  operators, onSave}) {

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const [operator, setOperator] = useState(null);
    const [code, setCode] = useState(null);
    const [description, setDescription] = useState(null);

    useEffect(() => {
        if (!tbInfo) {
            return;
        }
        if (operators) {
            const operator = operators.find(op => op?.id === tbInfo?.operatorId);
            setOperator(operator);
        }
        setDescription(tbInfo.description);
        setDescription(tbInfo.code);
    }, [tbInfo, operators]);


    const handleClick = (e) => {
        setAnchorEl(e.currentTarget);
        if (operators) {
            const operator = operators.find(op => op.id === tbInfo.operatorId);
            setOperator(operator);
        }
        setDescription(tbInfo.description);
        setCode(tbInfo.code);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setOperator(null);
        setDescription(null);
        setCode(null);
    };

    const saveOrUpdateParameter = () => {
        const body = {
            id: tbInfo.id,
            code: code,
            description: description,
            operator: operator.id === -2 ? null : {id: operator.id},
            status: tbInfo.status || TB_STATUS_ACTIVE
        };
        onSave(body);
        handleClose();
    };

    const popover = () => {
        return (
            <Popover id={id}
                     open={open}
                     anchorEl={anchorEl}
                     onClose={handleClose}
                     anchorOrigin={{
                         vertical: 'bottom',
                         horizontal: 'right',
                     }}
                     transformOrigin={{
                         vertical: 'top',
                         horizontal: 'right',
                     }}
            >
                <div style={{padding: "10px", textAlign: "center"}}>
                    {tbInfo.id ? "Редактировать ТБ статус" : "Добавить ТБ статус"}
                </div>
                <div style={{padding: "10px", minWidth: "305px", maxWidth: "500px"}}>
                    <TextField label="Код ТБ"
                               name="code"
                               value={code}
                               onChange={(e) => setCode(e.target.value)}
                               disabled={!!tbInfo.id}
                               InputLabelProps={{shrink: true}}
                               style={{width: '100%', paddingBottom: '15px'}}
                    />
                    <MaterialUISelect
                        label="Оператор"
                        dropdownData={operators}
                        selectedValue={operator}
                        onSelectCallbackFunction={setOperator}
                        dataField='id'
                        displayedField='name'
                        isClearable={true}
                        styles={{root: {minWidth: "150px !important", padding: "0 0 15px 0"},
                            input: {height: "30px !important"},}}
                    />
                    <TextField label="Описание"
                               name="description"
                               value={description}
                               onChange={(e) => setDescription(e.target.value)}
                               InputLabelProps={{shrink: true}}
                               style={{width: '100%', paddingBottom: '15px'}}
                    />
                    <br/>
                    <br/>
                    <div className="text-right">
                        <IconButton disableFocusRipple size="medium" onClick={saveOrUpdateParameter}
                                    variant="contained"
                                    title="Сохранить">
                            <Done fontSize="medium"/>
                        </IconButton>
                        <IconButton disableFocusRipple size="medium" onClick={handleClose} variant="contained"
                                    title="Отмена">
                            <Cancel fontSize="medium"/>
                        </IconButton>
                    </div>
                </div>
            </Popover>
        )
    };

    return (
        <>
            <div className="" onClick={handleClick}>
                {button}
            </div>
            {anchorEl && popover()}

        </>
    );
}